import {Component, h} from "preact";
import {ICON_CHECK, ICON_CHECKBOX, ICON_CHECKBOX_CHECKED, ICON_RADIO, ICON_RADIO_CHECKED} from "../../../lib/icons";
import {classes} from "mojave/classes";
import {formatPrice} from "../../../lib/price";


export const SELECTION_ALL = 1;
//const SELECTION_SINGLE = 2;
const SELECTION_MULTI = 3;

/**
 * @typedef {{
 *      category: Membership.OptionsCategory,
 *      selectedItems: Object<number, boolean>,
 *      onSelectOption: function(number, Object<number, boolean>),
 * }} OptionsSelection.Props
 *
 * @typedef {{
 * }} OptionsSelection.State
 */
export class OptionsSelection extends Component
{
	/**
	 * @param {OptionsSelection.Props} props
	 * @param {OptionsSelection.State} state
	 * @returns {null|JSX.Element}
	 */
	render (props, state)
	{
		return (
			<div class="_membership-options-selection">
				<div class="_membership-option-headline">{props.category.headline}</div>
				<div class="_membership-option-choices">
					{props.category.options.map(option => this.renderOption(
						option,
						props.category.id,
						props.selectedItems,
						props.category.selectionMethod
					))}
				</div>
			</div>
		);
	}


	/**
	 * @private
	 * @param {Membership.Option} option
	 * @param {number} categoryId
	 * @param {Object<number, boolean>} selectedItems
	 * @param {number} selectionMethod
	 * @returns {JSX.Element}
	 */
	renderOption (option, categoryId, selectedItems, selectionMethod)
	{
		/** @type {OptionsSelection.Props} props */
		const props = this.props;
		let isSelected = selectedItems[option.id] || false;
		let widget;
		let selectable = false;
		let optionProps = {};
		let formattedPrice = formatPrice(option.price);

		if (SELECTION_ALL === selectionMethod)
		{
			isSelected = true;
			widget = ICON_CHECK;
		}
		else if (SELECTION_MULTI === selectionMethod)
		{
			selectable = true;
			widget = isSelected ? ICON_CHECKBOX_CHECKED : ICON_CHECKBOX;

			optionProps.onClick = () =>
			{
				// just toggle the render item here
				selectedItems[option.id] = !selectedItems[option.id];
				props.onSelectOption(categoryId, selectedItems);
			};
		}
		else
		{
			selectable = true;
			widget = isSelected ? ICON_RADIO_CHECKED : ICON_RADIO;
			optionProps.onClick = () =>
			{
				// overwrite all other options here
				props.onSelectOption(categoryId, {
					[option.id]: !isSelected,
				});
			};
		}

		return (
			<div
				class={classes({
					"_membership-option-choice": true,
					"_membership-is-selectable": selectable,
					"_membership-is-selected": isSelected,
				})}
				{...optionProps}
			>
				<div class="_membership-choice-widget">{widget}</div>
				<div class="_membership-choice-name">{option.name}</div>
				{option.description != null && (
					// eslint-disable-next-line react/no-danger
					<div class="_membership-choice-description" dangerouslySetInnerHTML={{__html: option.description}}/>
				)}
				{formattedPrice !== null && (
					<div class="_membership-choice-price">{formattedPrice}</div>
				)}
			</div>
		);
	}
}
